/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IParkingItem {
  /** Тип парковки **/
  type: EType;
  /** Значение **/
  title: string;
  /** Кол-во уровней **/
  levels?: TParkingItem_Levels;
  /** Кол-во мест **/
  lots?: TParkingItem_Lots;
}

export enum EType {
  /** Подземная **/
  'Underground' = 'underground',
  /** Отдельная многоуровневая **/
  'Standalone' = 'standalone',
  /** Гостевая **/
  'Guest' = 'guest',
}
export type TParkingItem_Levels = null | number;

export type TParkingItem_Lots = null | number;
